import { css } from '@emotion/react';

/**
 * The card every admin config page groups a section into. The same block is inlined in several of
 * these pages already; new ones import it rather than adding another copy that a border change
 * would silently miss.
 */
export const configSectionCss = css`
  background: var(--mui-colors-primary-0);
  border: 1px solid var(--mui-colors-border-card);
  border-radius: 12px;
  /* No token for a two-layer card shadow; both layers are primary[100] at 4% and 6%. */
  box-shadow:
    0 1px 2px rgba(16, 37, 62, 0.04),
    0 2px 8px rgba(16, 37, 62, 0.06);
  padding: 16px 20px;
`;
